const scriptId = "taxi-claim-google-analytics";
let initialised = false;

/**
 * Reports a step of the journey to Google Analytics.
 *
 * The measurement id is passed in rather than held here: it comes from the environment's settings,
 * so the client can change the property, or be given one at all, without a release. The caller is
 * what decides whether to report anything - see TaxiClaimPage.
 */
export function trackTaxiClaimStep(measurementId: string, step: string, photoNumber?: number) {
	const analyticsWindow = window as any;
	if (!initialised) {
		analyticsWindow.dataLayer = analyticsWindow.dataLayer || [];
		analyticsWindow.gtag = analyticsWindow.gtag || function() {
			analyticsWindow.dataLayer.push(arguments);
		};
		// Use a fixed URL so query parameters and personal details never enter analytics.
		const pageLocation = `${window.location.origin}/taxi-submit`;
		analyticsWindow.gtag("js", new Date());
		analyticsWindow.gtag("config", measurementId, {
			send_page_view: false,
			page_location: pageLocation,
			page_title: "Driving Green taxi claim"
		});
		if (!document.getElementById(scriptId)) {
			const script = document.createElement("script");
			script.id = scriptId;
			script.async = true;
			script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
			document.head.appendChild(script);
		}
		analyticsWindow.gtag("event", "page_view", {
			send_to: measurementId,
			page_location: pageLocation,
			page_title: "Driving Green taxi claim"
		});
		initialised = true;
	}
	const parameters: {[key: string]: string | number} = {send_to: measurementId, journey_step: step};
	if (photoNumber !== undefined) parameters.photo_number = photoNumber;
	analyticsWindow.gtag("event", "taxi_claim_step", parameters);
}
